import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const adoptionPipeInspectionGuard = createFeatureGuard(Feature.AdoptionPipeInspection);
